<script lang="ts">
    import { Button } from "sveltestrap";
    import AppWraper from "../components/AppWraper.svelte";
    import RegisterModalExternalAntecedents from "../components/RegisterModalExternalAntecedents.svelte";
    import type { RegisterExternalBackground } from "../Model/RegisterExternalBackground";
    import { recordsExternalBackgroundService } from "../services";
    import { dateLocalInputFormatter } from "../services/Functions";
    import { v4 as uuidv4 } from 'uuid';
    import FilterRegisterAntecedent from "../components/FilterRegisterAntecedent.svelte"
    import { getCurrentUser } from "../services/session";

    let editRegister = null;
    let registers: any[];
    let offset = 0;
    let limit = 25;
    let searchFilter = {
        thirdName : null,
        selectOrigin : null,
        selectAntecedent : null,
        date : null
    };

    let startDate = null;
    let endDate = null;
    let newRegisters = false;
    
    let date = new Date();

    $: loadInputDate();

    async function loadRegisters(searchFilter = null): Promise<void> {
        let opts = {
            offset : offset,
            limit : limit,
            filters : {
                search: searchFilter
            }
        }

        registers = await recordsExternalBackgroundService.findRegisters(opts);
        
        registers.sort((a,b) => {
            return a.dateCreated < b.dateCreated ? -1 : 1;
        })
    }

    function newRegister(){
        newRegisters = true;

        editRegister = {
            id: uuidv4(),
            origin: null,
            originName: null,
            dateCreated: null,
            thirdId: '',
            thirdName: '',
            antecedentType: null,
            antecedentTypeName: null,
            deadlineDate: null,
            userId: getCurrentUser().id
        }
    }

    function registerUpdate(register: RegisterExternalBackground): void {
        console.log(register)
        let registerAct = registers.find(u => u.id == register.id)

        if (registerAct) {
            registerAct = register
            registers = registers;
        }else{
            registers = [...registers, register];
        }
    }

    function loadInputDate() {
        let startMonth = '0'; 
        let month = '0';
        if (date.getMonth() < 10 ) {
            month += date.getMonth()+1;
            startMonth += date.getMonth();
        } else {
            month = `${date.getMonth() + 1}`;
            startMonth = `${date.getMonth()}`;
        }
        let year = date.getFullYear()
        let day = date.getDate()

        startDate = year + '-' + startMonth + '-' + day;
        endDate = year + '-' + month + '-' + day;

        let selectedDates = [startDate, endDate];
        searchFilter.date = selectedDates;

        loadRegisters(JSON.stringify(searchFilter));
    }

</script>

<style>

</style>

<AppWraper>
    <div class="container-fluid p-5">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-9 mb-3">
                    <div class="text-start">
                        <h3>Registros Antecedentes Externos</h3>
                    </div>
                </div>
                <div class="col-12 col-sm-3 mb-3">
                    <div class="text-end">
                        <Button color="success" on:click={() => newRegister()}>
                            Nuevo Registro
                        </Button>
                    </div>
                </div>
            </div>

            {#if registers}
            <FilterRegisterAntecedent bind:searchFilterComponent={searchFilter} on:load={() => loadRegisters(JSON.stringify(searchFilter))} />

            <div class="row mt-3">
                <div class="col-12">
                    {#if registers?.length}
                    <table class="table">
                        <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Procedencia</th>
                                    <th scope="col">Antecedentes</th>
                                    <th scope="col">Fecha</th>
                                </tr>
                        </thead>
                        <tbody>
                            {#each registers as register, index }
                                <tr>
                                    <th scope="row">{index + 1}</th>
                                    <td>
                                        {#if register.thirdName}
                                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                                            <p class='btn btn-link' on:click={() => {editRegister = register; newRegisters = false}}>
                                                {register.thirdName}
                                            </p>
                                        {/if}
                                    </td>
                                    <td>
                                        {#if register.originName}
                                            {register.originName}
                                        {/if}
                                    </td>
                                    <td>
                                        {#if register.antecedentTypeName}
                                            {register.antecedentTypeName}
                                        {/if}
                                    </td>
                                    <td>
                                        {#if register.dateCreated}
                                            {dateLocalInputFormatter(register.dateCreated)}
                                        {/if}
                                    </td>
                                </tr>
                            {/each}
                        </tbody>
                    </table>
                    {:else}
                        <div class="text-center pt-5">
                            <hr>
                            <h3>No hay registros para mostrar</h3>
                        </div>
                    {/if}
                </div>
            </div>
        {/if}
        
        
        </div>
    </div>
    <RegisterModalExternalAntecedents register={editRegister}  bind:newRegister={newRegisters} on:registerUpdate={() => registerUpdate(editRegister)}/>

</AppWraper>



